const createFilterData = (filterValues=[], page=0, rowsPerPage=10) => {
  const data = {
    pageNo: page,
    pageSize: rowsPerPage,
  };

  filterValues.forEach((filter) => {
    const { id, value } = filter;
    data[id] = [value];
  });

  return data;
};

export default createFilterData;
